import { useEffect } from "react";
import { v4 as uuid } from "uuid";
import { IContainerApp } from "../../navigationButtonComponents/loansTab/containerApp/IContainerApp";
import ApplyRequestSteps from "./applyRequestSteps/applyRequestSteps";
import IdentityInformation from "../identity/identityInformation";
import ResidenceInformation from "../residence/residenceInformation";
import JobInformation from "../../jobInformation/jobInformation";
import WaitCheque from "../cheques/waitCheque";
import { TInnerStateForm } from "./IFormInnerState";
import GuarantorContainer from "../../navigationButtonComponents/guarantorContainer/guarantorContainer";
import WaitSign from "../../signContract/waitSign";
import KycVideo from "../../videoAuthorization/kycVideo";
import DrawerBody from "../drawerBody/drawerBody";
import LayoutWithoutDrawer from "../../../layouts/LayoutWithoutDrawer";
import AdditionalFields from "../additionInfo/additionalFields";
import AdditionalStep from "../additionInfo/additionalStep";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
export default function WaitCustomersDocument({ referenceKey, setStep }: IContainerApp) {
    const navigate = useNavigate();
    const setFormInnerState = (state: TInnerStateForm) => navigate(`/loans/request/${state === 'formList' ? '' : state}`);
    return (
        <Routes>
            <Route index element={<DrawerBody>
                <ApplyRequestSteps referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
            </DrawerBody>} />
            <Route path="Identity" element={<DrawerBody>
            <IdentityInformation referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
            </DrawerBody>} />
            <Route path="KycVideo/*" element={<LayoutWithoutDrawer>
            <KycVideo referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
            </LayoutWithoutDrawer>} />
            <Route path="Residential" element={<DrawerBody>
            <ResidenceInformation referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
            </DrawerBody>} />
            <Route path="Incomes" element={<DrawerBody>
            <JobInformation referenceKey={referenceKey} setFormInnerState={setFormInnerState} setStep={setStep} />
            </DrawerBody>} />
            <Route path="Cheque/*" element={<DrawerBody>
            <WaitCheque setFormInnerState={setFormInnerState} setStep={setStep} referenceKey={referenceKey} />
            </DrawerBody>} />
            <Route path="Guarantors/*" element={<DrawerBody>
            <GuarantorContainer setFormInnerState={setFormInnerState} setStep={setStep} referenceKey={referenceKey} />
            </DrawerBody>} />
            <Route path="AdditionalFields" element={<DrawerBody>
            <AdditionalFields setFormInnerState={setFormInnerState} setStep={setStep} referenceKey={referenceKey} />
            </DrawerBody>} />
            <Route path="*" element={<Navigate to="/loans/request" replace />} />
        </Routes>
    )
}
